import {Injectable} from '@angular/core'
import {HttpClient} from '@angular/common/http'
import {logger} from 'nx/src/utils/logger'
import {catchError, Observable, of} from 'rxjs'
import {PaymentResponse} from "../../../domain/src/lib/payment.model"
import {environment} from "../../../../apps/frontend/src/environments/environment"
import {
  DriverModel,
  ResponsibilityModel,
  ResponsibleModel,
  VResponsibilityModel,
} from "../../../domain/src/lib/driver.model"


@Injectable({
  providedIn: 'root',
})
export class DriverService {

  constructor(
      private readonly http: HttpClient,
  ) {
  }


  getActiveDrivers(): Observable<DriverModel[]> {
    const url = `${environment.apiUrl}/drivers?active=true`
    return this.http.get<DriverModel[]>(url)
  }


  /*
  getWorkdayDrivers(workDate: string): Observable<WorkdayDriverModel> {
    const url = `${environment.apiUrl}/workdays/drivers?workDate=${workDate}`
    return this.http.get<WorkdayDriverModel>(url)
  }
   */


  getResponsibilitiesFromCurrentWeek(): Observable<ResponsibilityModel[]> {
    const url = `${environment.apiUrl}/responsibilities/from-current-week`
    return this.http.get<ResponsibilityModel[]>(url)
  }


  getResponsibilitiesCurrent(fromDate: string): Observable<VResponsibilityModel[]> {
    const url = `${environment.apiUrl}/responsibilities/current/${fromDate}`
    return this.http.get<VResponsibilityModel[]>(url)
  }

  getVResponsibilitiesFromDateToSunday(fromDate: string): Observable<VResponsibilityModel[]> {
    const url = `${environment.apiUrl}/responsibilities/from-date-to-sunday/${fromDate}`
    return this.http.get<VResponsibilityModel[]>(url)
  }


  addResponsibility(responsibility: ResponsibilityModel): Observable<number> {
    const url = `${environment.apiUrl}/responsibilities`
    return this.http.post<number>(url, responsibility)
  }


  updateResponsibility(responsibility: ResponsibilityModel): Observable<number> {
    const url = `${environment.apiUrl}/responsibilities`
    return this.http.put<number>(url, responsibility)
  }


  deleteResponsibilitiesByIds(ids: number[]): Observable<unknown> {
    const url = `${environment.apiUrl}/responsibilities/${ids}`
    return this.http.delete(url).pipe(
        catchError(this.handleError('deleteResponsibility')),
    )
  }


  getResponsibles(): Observable<ResponsibleModel[]> {
    const url = `${environment.apiUrl}/responsibles`
    return this.http.get<ResponsibleModel[]>(url)
  }


  getDriverPaymentByYearMonthRange(driverUserId: number | null, fromYear: number, fromMonth: number, toYear: number, toMonth: number): Observable<PaymentResponse[]> {
    let url: string
    if (driverUserId == null || driverUserId == 0) {
      url = `${environment.apiUrl}/drivers/payments`
    } else {
      url = `${environment.apiUrl}/drivers/${driverUserId}/payments`
    }
    url += `?startYear=${fromYear}&startMonth=${fromMonth}&endYear=${toYear}&endMonth=${toMonth}`
    return this.http.get<PaymentResponse[]>(url)
  }


  /*
   // handleError(error: HttpErrorResponse, responsible?: ResponsibilityModel): Observable<ResponsibilityModel> {
   private handleError<T>(operation = 'operation', result?: T) {
   return (error: any): Observable<T> => {
   // TODO: send the error to remote logging infrastructure
   console.error(error) // log to console instead
   // TODO: better job of transforming error for user consumption
   this.log(`${operation} failed: ${error.message}`)
   // Let the app keep running by returning an empty result.
   return of(result as T)
   }
   }
   */

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<boolean> => {
      // TODO: send the error to remote logging infrastructure
      // TODO: better job of transforming error for user consumption
      logger.error(`${operation} failed: ${error.message}`)
      // Let the app keep running by returning an empty result.
      return of(false)
    }
  }

}
